import React from "react";
import { Link } from "react-router-dom";

export default function StandbyPage() {
  return (
    <div style={{ position: "relative", width: "100%", height: "100vh", overflow: "hidden", backgroundColor: "#000" }}>
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "translate(-50%, -50%)",
          zIndex: 0,
          opacity: 0.6,
        }}
      >
        <source src="/assets/quantum-loop.mp4" type="video/mp4" />
      </video>

      {/* Overlay Content */}
      <div style={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "#fff",
        textAlign: "center",
        padding: "20px"
      }}>
        <h1 style={{
          fontSize: "4rem",
          letterSpacing: "4px",
          marginBottom: "20px",
          background: "linear-gradient(to right, #00f260, #0575E6)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textTransform: "uppercase"
        }}>
          Oracle d'Entropie
        </h1>
        
        <p style={{
          fontSize: "1.2rem",
          maxWidth: "600px",
          color: "#ccc",
          marginBottom: "40px",
          letterSpacing: "1px"
        }}>
          Générateur d'Entropie Quantique & Certification Numérique
        </p>

        <Link to="/login" style={{
          padding: "15px 40px",
          fontSize: "1.2rem",
          fontWeight: "bold",
          color: "#fff",
          backgroundColor: "rgba(0, 255, 255, 0.1)",
          border: "2px solid #0ff",
          borderRadius: "30px",
          textDecoration: "none",
          transition: "all 0.3s ease",
          boxShadow: "0 0 15px rgba(0, 255, 255, 0.3)",
          textTransform: "uppercase",
          letterSpacing: "2px"
        }}
        onMouseOver={e => {
          e.currentTarget.style.backgroundColor = "rgba(0, 255, 255, 0.3)";
          e.currentTarget.style.boxShadow = "0 0 25px rgba(0, 255, 255, 0.6)";
        }}
        onMouseOut={e => {
          e.currentTarget.style.backgroundColor = "rgba(0, 255, 255, 0.1)";
          e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 255, 255, 0.3)";
        }}
        >
          Accéder au Hub
        </Link>
      </div>


    </div>
  );
}
